const SnackbarTypes = Object.freeze({
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    ERROR: 'error',
});

export default SnackbarTypes;
